// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import AppDispatcher from 'dispatcher/app_dispatcher.jsx';
import {WebrtcActionTypes} from 'utils/constants.jsx';

import {Client4} from 'mattermost-redux/client';
import {CustomClient4} from 'custom-redux/client';

export function initWebrtc(userIds, isCalling,callType) {
    AppDispatcher.handleServerAction({
        type: WebrtcActionTypes.INITIALIZE,
        user_ids: userIds,
        is_calling: isCalling,
        call_type:callType
    });
}

export function handle(message) {
    AppDispatcher.handleServerAction({
        type: message.action,
        message
    });
}

export function webrtcToken(success, error) {
    Client4.webrtcToken().then(
        (data) => {
            if (success) {
                success(data);
            }
        }
    ).catch(
        () => {
            if (error) {
                error();
            }
        }
    );
}

export function createVclog(vclog,success, error) {
    CustomClient4.createVclog(vclog).then(
        (data) => {
            if (success) {
                success(data);
            }
        }
    ).catch(
        () => {
            if (error) {
                error();
            }
        }
    );
}

export function getVclog(userId,success, error) {
    CustomClient4.getVclog(userId).then(
        (data) => {
            if (success) {
                success(data);
            }
        }
    ).catch(
        () => {
            if (error) {
                error();
            }
        }
    );
}



// WEBPACK FOOTER //
// ./actions/webrtc_actions.jsx